import Card from 'components/general/Card/Card';
import Flash from 'components/general/Flash/Flash';
import Can, { Cannot } from 'containers/Can/Can';
import SEOMeta from 'containers/SEOMeta';
import SiteFlashes from 'containers/SiteFlashes';
import React, { Fragment } from 'react';
import BusinessInterestForm from './containers/BusinessInterestForm';

const RegisterBusinessInterest = () => (
  <Fragment>
    <SEOMeta title="Business plan" />
    <Card>
      <Card.Section>
        <SiteFlashes />
        <h1>GSI for Business</h1>
        <p>Our business plan gives your whole organisation the tools to 
          assess security risks, for a set annual fee.</p>
        {/* User is authenticated */}
        <Cannot action="use" feature="login">
          {/* Show a message if we're already a pro subscriber */}
          <Can action="read" on="GRM">
            <Flash
              type="success"
              message="You already have a GSI for business subscription."
            />
          </Can>
          {/* Otherwise show current status and a button to send preloaded form */}
          <Cannot action="read" on="GRM">
            <div className="u-space-no-pull">
              <Flash
                icon="info"
                type="accent"
                message="You currently have a standard subscription. 
                  Click the button below to request a free trial."
              />
              <BusinessInterestForm />
            </div>
          </Cannot>
        </Cannot>
        {/* User is not authenticated */}
        <Can action="use" feature="login">
          <BusinessInterestForm />
        </Can>
      </Card.Section>
    </Card>
  </Fragment>
);

export default RegisterBusinessInterest;
